import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {EntitlementResourceLogsCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const entitlementResourceChangeLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementResourceLogsCriteria
>('entitlementResourceChangeLogState', undefined);

export const entitlementResourceChangeLogStateActions = entitlementResourceChangeLogStateSlice.actions;
export const entitlementResourceChangeLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementResourceLogsCriteria
> = state => state.manageEntitlements.entitlementResourceChangeLogReducer.state;
